// extracted by mini-css-extract-plugin
export var closeButton = "announcement-bar-module--closeButton--26fda";
export var content = "announcement-bar-module--content--1f7cd";
export var root = "announcement-bar-module--root--7b836";
export var wrapper = "announcement-bar-module--wrapper--35662";